import axios from 'axios'
import getHeaders from '../helpers/headers'
import config from '../../constants/endpoints.js'

const {
  endpoints: {
    account: { signup: url },
  },
} = config

/**
 * Signs up with user and company data
 * @param {Object} data.user User data
 * @param {Object} data.company Company data
 */
export const signup = (data) => axios.post(url, data, { headers: getHeaders() })

/**
 * Activates the user account
 * @param {Object} data.user User data
 * @param {Object} data.company Company data
 */
export const activate = ({ data, token }) => axios.put(`${url}?token=${token}`, data, { headers: getHeaders() })
